export default __webpack_public_path__ + "static/media/slide12.7d6cd79b.jpg";